import { RefObject, useCallback, useEffect } from 'react';

export const useFocusedActions = ({
  ref,
  triggerKeys = ['Enter', ' '],
  onAction,
}: {
  ref: RefObject<HTMLElement | null>;
  triggerKeys?: string[];
  onAction: () => void;
}) => {
  const keyPressHandler = useCallback(
    (e: KeyboardEvent) => {
      if (ref.current !== document.activeElement) return;

      if (triggerKeys?.includes(e.key) && !e.shiftKey) {
        e.preventDefault();
        onAction();
      }
    },
    [onAction, ref, triggerKeys],
  );

  useEffect(() => {
    document.addEventListener('keypress', keyPressHandler);
    return () => {
      document.removeEventListener('keypress', keyPressHandler);
    };
  }, [keyPressHandler]);
};
